module.exports = __webpack_public_path__ + "media/images/emblems/Niederweningen-blazon-b635200e4d21371a3fd5d45c100c852e.svg";